import { instance } from "api/apiBase";
import { AxiosError } from "axios";

interface CodeboxStatusResponse {
  connected: boolean;
}

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/codebox";

const handleCodeboxError = (error: unknown): never => {
  const axiosError = error as AxiosError;
  if (axiosError.response?.status === 422)
    throw new Error(
      "Connection failed. Please check your credentials and try again."
    );
  throw error;
};

export const codeboxApi = {
  getStatus: async (): Promise<CodeboxStatusResponse> => {
    const { data } =
      await instance.get<CodeboxStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (payload: {
    username: string;
    password: string;
  }): Promise<CodeboxStatusResponse> => {
    try {
      const { data } = await instance.post<CodeboxStatusResponse>(
        BASE_ENDPOINT_URL,
        payload
      );
      return data;
    } catch (error) {
      return handleCodeboxError(error);
    }
  },

  disconnect: async (): Promise<CodeboxStatusResponse> => {
    const { data } =
      await instance.delete<CodeboxStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  }
};
